import ReleaseDynamicFormTypes from "../Types/ReleaseDynamicFormTypesTypes"

const releaseDynamicFormBoiler: ReleaseDynamicFormTypes = {
        PortalDynamicFormDistributionId: null,
        CustomFormId: null,
        FormDistributeTo: "Employee",
        Value: null,
        DistributionPoint: "Web",
        ExpirationDate: null,
        ApprovedDate: null,
        ApprovedBy: null,
        DistributionPointName: ""
    
}
export default releaseDynamicFormBoiler